<template>
  <header
    :class="{
      'md:items-stretch md:m-auto md:py-4 md:max-w-2xl md:justify-start': !forceSmStyle,
    }"
    class="p-6 flex items-center justify-between"
  >
    <div
      :class="{
        'md:flex-none md:mr-6 md:h-9': !forceSmStyle,
      }"
      class="flex-1"
    >
      <template
        v-if="backRoute"
      >
        <router-link
          :to="backRoute"
          :class="{'md:hidden': !forceSmStyle}"
          class="border border-grey-light h-10 w-10 rounded-full flex
          items-center justify-center back-button"
          tag="button"
        >
          <Back />
        </router-link>
        <BaseLogo
          v-if="!forceSmStyle"
          class="hidden md:block p-2px"
        />
      </template>
      <BaseLogo
        v-else
        :class="{'md:p-0': !forceSmStyle}"
        class="p-2px"
        @click="$router.push('/')"
      />
    </div>
    <TheNavbar v-if="withMenu" />
    <TheNavbarRightItem v-if="withMenu" />
    <div
      :class="{
        'md:hidden': !forceSmStyle
      }"
      class="text-center flex-1"
    >
      <BaseSubtitle
        v-if="centerTitle"
        :subtitle="centerTitle"
      />
    </div>
    <div
      :class="{
        'md:hidden': !forceSmStyle
      }"
      class="flex-1 flex flex-col items-end"
    >
      <router-link
        v-if="forwardRoute"
        :to="forwardRoute"
        class="border border-grey-light h-10 w-10 rounded-full justify-center flex items-center"
        tag="button"
      >
        <Forward />
      </router-link>
      <TheHeaderBurgerMenu
        v-if="withMenu"
        class="md:hidden"
      />
      <div
        v-if="withClose"
        class="flex items-center cursor-pointer"
        @click="close"
      >
        <BaseSubtitle
          subtitle="fermer"
          class="mr-2"
        />
        <span class="text-2xl">×</span>
      </div>

      <div
        v-if="withCross"
        class="p-4 rounded-full border border-grey-light flex items-center"
        @click="close"
      >
        <Cross />
      </div>
    </div>
  </header>
</template>

<script>
import BaseLogo from './BaseLogo.vue';
import TheHeaderBurgerMenu from './TheHeaderBurgerMenu.vue';
import BaseSubtitle from './BaseSubtitle.vue';
import TheNavbar from './TheNavbar.vue';
import TheNavbarRightItem from './TheNavbarRightItem.vue';
import Back from './icons/Back.vue';
import Forward from './icons/Forward.vue';
import Cross from './icons/Cross.vue';

export default {
  name: 'TheHeader',
  components: {
    BaseLogo,
    TheHeaderBurgerMenu,
    BaseSubtitle,
    TheNavbar,
    TheNavbarRightItem,
    Back,
    Forward,
    Cross,
  },
  props: {
    forceSmStyle: {
      type: Boolean,
      default: false,
    },
    withMenu: {
      type: Boolean,
      default: false,
    },
    withClose: {
      type: Boolean,
      default: false,
    },
    withCross: {
      type: Boolean,
      default: false,
    },
    backRoute: {
      type: String,
      default: null,
    },
    forwardRoute: {
      type: String,
      default: null,
    },
    centerTitle: {
      type: String,
      default: null,
    },
    rightItem: {
      type: Object,
      default: null,
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>
